module.exports = __webpack_public_path__ + "img/6-1-1.d0e5ad26.png";